import ZMap from './map.vue'

export default ZMap
